module.exports = __webpack_public_path__ + "img/hpv.16745ef0.png";